import { userDate } from '../owaDate';
import type { OwaDate } from '../schema';

export default (): OwaDate => userDate();
